<template>
  <v-data-table-server
    v-model:items-per-page="pagination.limit"
    :items="judges"
    :items-length="count"
    :loading="isLoading"
    :headers="headers"
    :search="pagination.q"
    item-key="id"
    class="elevation-1"
    @update:options="handleLimitChange">
    <template v-slot:[`item.specialities`]="{ item }">
      <v-chip v-if="item.specialities.length > 0" v-for="spec of item.specialities">{{
        spec.name
      }}</v-chip>
    </template>
    <template v-slot:top>
      <v-text-field
        v-model="pagination.q"
        class="ma-2"
        density="compact"
        placeholder="Search films..."
        hide-details></v-text-field>
    </template>
  </v-data-table-server>
</template>
<script setup lang="ts">
import { IBranchYearJudgeDTO, IBranchYearRoundDTO, IPaginationDTO, PaginationDTO } from '@/dtos';
import { useSnack } from '@/helpers';
import { useUpdateStatusStore } from '@/stores';
import { useAdminJudgeStore } from '@/stores/modules/admin';
import { SNACKSTATUS } from '@/stores/util';
import { computed, ref } from 'vue';
import type { VDataTableServer } from 'vuetify/components';

interface Props {
  round: IBranchYearRoundDTO;
}
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);

const props = defineProps<Props>();
const round = computed(() => props.round);
const branchYear = computed(() => props.round.branchYear);
const branchId = computed(() => branchYear.value.branch?.id || '');
const yearId = computed(() => branchYear.value.year?.id || '');

const pagination = ref<IPaginationDTO>(new PaginationDTO());
const judgeStore = useAdminJudgeStore();
const { data, isLoading } = judgeStore.getBranchYearJudgeFilms(branchId, yearId, pagination);

const headers = [
  { title: 'First Name', key: 'judge.first_name' },
  { title: 'Last Name', key: 'judge.last_name' },
  { title: 'Email', key: 'judge.email_address' },
  { title: 'Specialities', key: 'specialities' },
  { title: 'Actions', key: 'actions', sortable: false },
];

const handleLimitChange = (value: VDataTableServer) => {
  pagination.value.buildPagination(value);
};
</script>
